import script from "./check-docs.vue?vue&type=script&setup=true&lang=js"
export * from "./check-docs.vue?vue&type=script&setup=true&lang=js"

import "./check-docs.vue?vue&type=style&index=0&id=569c61ea&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-569c61ea"]])

export default __exports__